module.exports = {"component":"app-launcher","status":"prod","display-name":"App Launcher","classKey":"AppLauncher","SLDS-component-path":"/components/app-launcher","dependencies":[{"component":"expandable-section","classKey":"AppLauncherExpandableSection"},{"component":"link","classKey":"AppLauncherLink"},{"component":"tile","classKey":"AppLauncherTile"}],"site-stories":[{"heading":"Default","path":"/__examples__/default.jsx"}],"url-slug":"app-launcher"}


//////////////////
// WEBPACK FOOTER
// ./~/@salesforce/design-system-react/lib/components/app-launcher/component.json
// module id = 189
// module chunks = 0